import { useQuery } from "@tanstack/react-query";
import moment from "moment";

import { getDataSubmissionDates, getDataSubmissionDatesAdmin } from "services";

import { getEnvironment, getIsSubmissionPeriodOpen, useGetCarbonProgramByFarmId } from "utils";

import { GET_DATA_SUBMISSION_DATES } from "consts";

import { DataSubmissionDatesResponse } from "models";

const isAdmin = getEnvironment().admin;

export const useGetDataSubmissionDates = ({ farmId }: { farmId?: string }) => {
  const { data: carbonProgram } = useGetCarbonProgramByFarmId(farmId);
  const startYear = carbonProgram?.fieldsManagement.startYear;

  return useQuery({
    queryKey: [GET_DATA_SUBMISSION_DATES, startYear, carbonProgram?.id, isAdmin],
    queryFn: async () => {
      const resp = isAdmin ? await getDataSubmissionDatesAdmin(carbonProgram?.id) : await getDataSubmissionDates();

      if (startYear && startYear > moment(resp.submissionStartDate).year()) {
        for (const [key, date] of Object.entries(resp)) {
          resp[key as keyof DataSubmissionDatesResponse] = moment(date).year(startYear).toISOString();
        }
      }

      const isSubmissionPeriodOpen = getIsSubmissionPeriodOpen(resp.submissionStartDate, resp.submissionEndDate);

      return { ...resp, isSubmissionPeriodOpen };
    },
  });
};
